import React, { useEffect, useState } from "react";
import { detectprogress } from "../../../api/aidetect/detectApi";
import "./Progress.css";
import { useTranslation } from 'react-i18next';

const Progress = () => {
  const { t } = useTranslation('utils');
  const [progressData, setProgressData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProgress = async () => {
      try {
        setLoading(true);
        const res = await detectprogress();
        setProgressData(res.data);
      } catch (err) {
        console.error("⚠️ Progress API 호출 실패:", err);
        setError("진행도 정보를 불러오는 중 오류가 발생했습니다.");
      } finally {
        setLoading(false);
      }
    };

    fetchProgress();
    const interval = setInterval(fetchProgress, 5000);
    return () => clearInterval(interval);
  }, []);

  if (loading) return <p>{t("progress.loding")}</p>;
  if (error) return <p style={{ color: "red" }}>{error}</p>;
  if (!progressData) return <p>{t("progress.nodata")}</p>;

  const tasks = progressData.tasks || {};

  const renderProgressBar = (percent) => {
    const filledBlocks = Math.round(percent / 5);
    const emptyBlocks = 20 - filledBlocks;
    return "█".repeat(filledBlocks) + "░".repeat(emptyBlocks);
  };

  const renderStatus = (percent) => {
    if (percent >= 100) return <span className="status done">{t("progress.complete")}</span>;
    if (percent > 0) return <span className="status working">{t("progress.progressing")}</span>;
    return <span className="status waiting">{t("progress.wait")}</span>;
  };

  return (
    <div className="ProgressContainer">
      <h3>{t("progress.title")}</h3>

      <table className="ProgressTable">
        <thead>
          <tr>
            <th>{t("progress.id")}</th>
            <th>{t("progress.progress")}</th>
            {/* <th>메시지</th> */}
            <th>{t("progress.state")}</th>
          </tr>
        </thead>
        <tbody>
          {Object.entries(tasks).map(([id, task]) => (
            <tr key={id}>
              <td className="task-id">{id}</td>
              <td className="progress-bar">
                <span className="bar-text">
                  {renderProgressBar(task.progress)} {task.progress}%
                </span>
              </td>
              {/* <td>{task.message || "메시지 없음"}</td> */}
              <td>{renderStatus(task.progress)}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <p className="total">{t("progress.total")}: {progressData.total_tasks}</p>
    </div>
  );
};

export default Progress;
